export enum SubmittalTypeEnum {
    Aya = 0,
    APN = 1
}

export enum AyaInterviewEnum {
    ClientOffer1 = 1,
    ClientOffer2 = 2,
    AyaOffer = 4
}

export enum AyaInterviewEnumSimple {
    ClientOffer = 'Client Offer',
    AyaOffer = 'Aya Offer'
}

export enum SubmittalInactiveTypeEnum {
    Queued = 1,
    PendingInformation = 2
}
